import React, { useEffect, useRef, useState, useContext } from "react";
import { BarChart, Bar,Cell, XAxis,YAxis, CartesianGrid, Tooltip,Legend, ResponsiveContainer } from "recharts";
import ReactSlider from "react-slider";
import '../Slider/DoubleSlider';
import Buttons from "react-multi-date-picker/components/button";
import { ButtonLoader } from "../Loaders/ButtonLoader";
import { isBrowser, isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import {AppContext} from "../../../AppContextProvider";
import { VitrineContext } from "../../vitrines/VitrineContext";
const Histogram = ({histograms=[],filters={},setFilters=()=>{},ApplyFilters=()=>{}})=>
{
    const rectNbr = useRef(10);
    const [extremus,setExtremus] = useState({min:0,max:0});
    const [values,setValues] = useState([0,0]);
    const [histogram,setHistogram] = useState([]);
    const [AppState,setAppState] = useContext(AppContext);
    const { t } = useTranslation();

    useEffect(()=>{
        if (!histograms || histograms.length === 0) return;

        let prices = [];
        let _data_obj = {};
    
        histograms.forEach(hist=>{
            prices = prices.concat(Object.keys(hist));
            Object.entries(hist).map(([key, value]) => {
                if(key in _data_obj)
                    _data_obj[key] = _data_obj[key]+value;
                else
                    _data_obj[key] = value;
            }); 
        });

        if (prices.length === 0) return;
        
        const delta_price = AppState.settings.devise==='euro'?50:25000;

        let _min = prices.reduce((min,val)=> Number(val) < Number(min) ? Number(val) : min, Number(prices[0]))-delta_price;
        let _max = prices.reduce((max,val)=> Number(val) > Number(max) ? Number(val) : max, Number(prices[0]))+delta_price;
        _min = _min<0?0:_min;
        _max = _max<0?0:_max;
        const newHistogram = Object.entries(_data_obj).map(([label, count]) => ({
                label,
                count,
                color: 'skyblue',}));
        
        setHistogram(newHistogram);
        if(_min !== extremus.min || _max !== extremus.max)
        {
            setExtremus({min:_min,max:_max});
            setExtremus({ min: _min, max: _max });
            setValues([_min, _max]);
        }
    },[histograms])

    useEffect(()=>{
        setFilters(prev => ({ ...prev, prices: {min:values[0], max: values[1]} }));
        console.log(filters);
    },[values])

    const MyToolTip = ({active, playload, label})=>{
        if(active && playload && playload.length)
        {
            return(
                <div>
                    <p>{label}</p>
                </div>
            );
        }
        return null;
    }

    return(
    <div >
        <ResponsiveContainer width={"100%"} height={225}>
            <BarChart
                data={histogram}
                margin={{top:5, right:10, left:10, bottom:5}}
            >
                <CartesianGrid strokeDasharray="33" />
                <Tooltip content={<MyToolTip />} cursor={false} />
                <Bar activeBar={false} dataKey={"count"}>
                      {histogram.map((entry, index) => {
                        const value = entry.label;
                        const isOutOfRange = Number(value) < values[0] || Number(value) > values[1];
                        return (
                        <Cell
                            key={`cell-${index}`}
                            fill={isOutOfRange ? 'lightgray' : 'skyblue'}
                        />
                        );
                    })}
                </Bar>
                <XAxis dataKey={"label"} />
            </BarChart>
        </ResponsiveContainer>
        <div style={{margin:'0px 0px 10px 0px'}} className="slider-container">
            <ReactSlider
                className="horizontal-slider"
                thumbClassName="thumb"
                trackClassName="track"
                defaultValue={[extremus.min, extremus.max]}
                ariaLabel={['Lower thumb', 'Upper thumb']}
                ariaValuetext={state => `Thumb value ${state.valueNow}`}
                min={extremus.min}
                max={extremus.max}
                step={((extremus.max-extremus.min)/10)}
                value={values}
                onChange={(newValues) =>{
                    if(!!newValues[0])
                        setValues(newValues)
                    }}
                renderTrack={(props,state)=>(
                <div {...props}  key={`key-${state.index}`} 
                    className={`${props.className} track-${state.index}`} />
                )}
            />
            <div className="values" style={{fontSize:'xx-small'}}>
                <span>{values[0]}<span style={{color:'lightgray'}}> {AppState.settings.devise==='euro' ? '€' : 'KMF'}</span></span>
                <span>{values[1]}<span style={{color:'lightgray'}}> {AppState.settings.devise==='euro' ? '€' : 'KMF'}</span></span>
            </div>
        </div>
    </div>
    );
    }
export default Histogram